var styleDataHash = "55308a70";
const injectCss = () => {
  var css = `.bhUkq{height:100%;position:absolute;top:0;width:100%;z-index:0}[dir] .bhUkq{border:0}[dir=ltr] .bhUkq{left:0}[dir=rtl] .bhUkq{right:0}.r7Dck{bottom:0;position:absolute;top:0;z-index:3}[dir=ltr] .r7Dck,[dir=rtl] .r7Dck{left:0;right:0}.da9ew{height:0;position:relative}[dir] .da9ew{padding-bottom:56.25%}@supports not (contain:inline-size){@media only screen and (max-width:640px){.da9ew{min-width:auto}}}@container (width < 640px){.da9ew{min-width:auto}}.h2qNk{bottom:0;height:100%;position:absolute;top:0;width:100%;z-index:1}[dir] .h2qNk{cursor:move}.a0wTE{align-items:center;bottom:0;display:flex;flex-direction:column;gap:12px;height:100%;justify-content:center;position:absolute;top:0;width:100%;z-index:1}[dir] .a0wTE{background:rgba(0,6,36,.7);cursor:move;padding:16px}.Ueys5{color:#fff}.a0wTE~*>*,.h2qNk~*>*{pointer-events:none}.vJd2P{height:0;overflow:hidden;visibility:hidden;width:0}.Fi-7B,.vJd2P{position:absolute}.Fi-7B{align-items:center;color:#fff;display:flex;font-size:20px;font-weight:400;height:100%;justify-content:center;top:0;width:100%;z-index:1}[dir] .Fi-7B{background:rgba(0,0,0,.5);text-align:center}[dir=ltr] .Fi-7B{right:0}[dir=rtl] .Fi-7B{left:0}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var default_video_styles_default = {
  "video_player": "bhUkq",
  "videoOverlay": "r7Dck",
  "video_container": "da9ew",
  "video_overlay": "h2qNk",
  "video_pending_overlay": "a0wTE",
  "video_pending_overlay_loader": "Ueys5",
  "hide_duration": "vJd2P",
  "error": "Fi-7B"
};
export {
  default_video_styles_default as default,
  injectCss
};
//# sourceMappingURL=default-video-styles-scss.js.map
